import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import {  Observable,Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class CompanySideBarTreeViewService {
  private createdCompanySubject = new Subject<void>();
  selectedCompany:any;
  
  constructor(
    private _apiService: ApiService
  ) { }

  private createdCompanyNameValue = new BehaviorSubject('');
  createdCompanyName = this.createdCompanyNameValue.asObservable();
  changecreatedCompanyName(message: string) {
    this.createdCompanyNameValue.next(message);
  }

  private companyEmpresaId = new BehaviorSubject("0");
  companyEmpresa = this.companyEmpresaId.asObservable();
  changeCompanyEmpresaId(message: string) {
    this.companyEmpresaId.next(message);
  }

  private companyEmpresaNameSubject = new BehaviorSubject('');
  companyEmpresaName = this.companyEmpresaNameSubject.asObservable();
  changeCompanyEmpresaName(message: string) {
    this.companyEmpresaNameSubject.next(message);
  }

  sendClickUpdateEvent(){
    this.createdCompanySubject.next();
  }
  getClickUpdateEvent():Observable<any>{
     return this.createdCompanySubject.asObservable();
  }

  GetTreeView(activo,emprasaname:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getTreeView}`;
    url = url.replace('{activo}', activo.toString());
    url = url.replace('{emprasaname}', emprasaname); 
    return this._apiService.get(url);
  }
  
   GetTreeViewStaff(activo, emprasaname:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.GetTreeViewStaff}`;
    url = url.replace('{activo}', activo.toString());
    url = url.replace('{emprasaname}', emprasaname); 
    return this._apiService.get(url);
  }
  CreateSubCompany(padreid:any,companyname:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.createSubCompany}`;
    url = url.replace('{padreid}', padreid);
    url = url.replace('{companyname}', companyname); 
    return this._apiService.put(url);
  }
  UpdateCompanyStatus(empresaid:any,status:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateCompanyStatus}`;
    url = url.replace('{empresaid}', empresaid);
    url = url.replace('{status}', status); 
    return this._apiService.put(url);
  }
  CloseLeaves(empresaid:any,currentuser:any,nameofuser:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.closeLeaves}`;
    url = url.replace('{empresaid}', empresaid);
    url = url.replace('{currentuser}', currentuser);
    url = url.replace('{nameofuser}', nameofuser);
    return this._apiService.put(url);
  }
  CloseLeavesMutua(empresaid:any,currentuser:any,nameofuser:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.closeLeavesMutua}`;
    url = url.replace('{empresaid}', empresaid);
    url = url.replace('{currentuser}', currentuser);
    url = url.replace('{nameofuser}', nameofuser);
    return this._apiService.put(url);
  }
  LockEmployeesNotWorking(empresaid:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.lockEmployeesNotWorking}`;
    url = url.replace('{empresaid}', empresaid);
    return this._apiService.put(url);
  }
  DeleteDataOfCompany(empresaid:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.deleteDataOfCompany}`;
    url = url.replace('{empresaid}', empresaid);
    return this._apiService.delete(url);
  }
  CheckCompanyChildren(empresaid:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.checkCompanyChildren}`;
    url = url.replace('{empresaid}', empresaid);
    return this._apiService.get(url);
  }
  WordNivelEmpresas(empresaid:any, activo): Observable<RestResponse> {
    let url = `${API.CompanyManagement.wordNivelEmpresas}`;
    url = url.replace('{empresaid}', empresaid);
    url = url.replace('{activo}', activo.toString());
    return this._apiService.get(url);
  }
  DeleteCompany(empresaid:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.deleteCompany}`;
    url = url.replace('{empresaid}', empresaid);
    return this._apiService.delete(url);
  }
  MoveCompany(treeempresaid:any,moveempresaid:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.moveCompany}`;
    url = url.replace('{treeempresaid}', treeempresaid);
    url = url.replace('{moveempresaid}', moveempresaid);
    return this._apiService.put(url);
  }
  
}
